import { IContextMenuItem } from '../../../interfaces/icontext-menu-item.interface';
import { ContextMenuItemBase } from '../../menu/context-menu-item-base';
import { FormBuilderComponent } from '../../../components/form-builder/form-builder.component';

// Define a class that implements IContextMewnuData.
export class FormBuilderContextMenuItemBase extends ContextMenuItemBase implements IContextMenuItem {
    // Private properties.
    protected readonly component: FormBuilderComponent;

    // Constructor.
    public constructor(itemTitle: string, component: FormBuilderComponent, submenus: IContextMenuItem[] = null) {
        super(itemTitle, submenus);

        this.component = component;
    }

    public get MenuItemDisabled(): boolean {
        return false; // Default behavior
    }

    // Implement a NOOP menuItemSelected() method.
    public menuItemSelected(contextItem: any, eventData: any): void {
        // NOTE:  this method is a NOOP by design as some menu items do not require an action (e.g. menus with submenus).
    }
}
